import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const KeyboardFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function KeyboardFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path fillRule="evenodd" clipRule="evenodd" d="M19 3H5C2.79 3 1 4.79 1 7v10c0 2.21 1.79 4 4 4h14c2.21 0 4-1.79 4-4V7c0-2.21-1.79-4-4-4Zm-6 4h2v2h-2V7Zm0 4h2v2h-2v-2ZM9 7h2v2H9V7Zm0 4h2v2H9v-2Zm-2 2H5v-2h2v2Zm0-4H5V7h2v2Zm9.5 8.5h-9v-2h9v2ZM19 13h-2v-2h2v2Zm0-4h-2V7h2v2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default KeyboardFilled;